export const SET_THEMES = 'SET_THEMES';
export const SET_THEME = 'SET_THEME';
export const ADD_THEME = 'ADD_THEME';
export const UPDATE_THEME = 'UPDATE_THEME';
export const REMOVE_THEME = 'REMOVE_THEME';
export const CLEAR_THEME = 'CLEAR_THEME';
export const CLEAR_THEMES = 'CLEAR_THEMES';
